<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">财务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">拉新佣金</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">拉新佣金</div>
      </div>
      <div class="panel-body">
        <!--<div class="alert-warn">
          请完善以下信息，方便我们更好的为您服务！
        </div>-->
        <form ref="form" class="zj-form form-horizontal" action="" style="visibility:hidden">
          <div class="form-group ub-box">
            <div class="zj-control-label">

            </div>
            <div class="zj-form-control validate-control">
              我的推广链接：{{tuiguangurl}}
            </div>
          </div>
          <div class="form-group ub-box">
            <div class="zj-control-label">

            </div>
            <div class="zj-form-control validate-control">
              推广语帮助：<a :href="cankaourl" target="_blank" class="z-color-a a-underline-link z-font-size-14">参考范本</a>
            </div>
          </div>
          <div class="form-group choose-verify-method ub-box">
            <div class="zj-control-label">

            </div>
            <div class="zj-form-control validate-control">
              我已经拥有用户 {{reg_user_num}}个 ，有效拉新用户 {{pay_user_num}}个
              <a target="_blank" class="z-color-a a-underline-link z-font-size-14" href="https://www.abeiyun.com/help/content_1172.html">什么是有效拉新用户</a>
            </div>
          </div>
          <div class="form-group choose-verify-method ub-box">
            <div class="zj-control-label">

            </div>
            <div class="zj-form-control">
              我们继续努力！加油！加油！
            </div>
          </div>
          <div class="form-group ub-box">
            <div class="zj-control-label">

            </div>
            <div class="zj-form-control">
              已提现：{{pay_ok}}元 未提现：{{pay_no}}元
            </div>
          </div>
          <div class="form-group ub-box">
            <div class="zj-control-label">
              &nbsp;
            </div>
            <div class="zj-form-control">
              <a href="javascript:;" class="zj-btn btn-strong" @click="savingInfo">提 现</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  /*import userService from 'business/userService.js'*/
  import XfromInput from 'commons/XfromInput.vue'
  import Xcity from 'commons/Xcity.vue'
  import userService from 'business/userService.js'
  export default {
    data () {
      return {
        DISTRICTS:[],
        listLoading:false,
        tuiguangurl:'',
        cankaourl:'',
        reg_user_num:'',
        pay_user_num:'',
        pay_ok:'',
        pay_no:'',
      }
    },
    components: {
      XfromInput,
      Xcity
    },
    props:{
      hide:Boolean
    },
    mounted(){
      this.config()
    },
    methods: {
      async config() {
        await this.getAllUser()
      },
      async getAllUser(urlType,data) {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=laxin_yongjin')
        if(state.code === '000' ) {
          this.tuiguangurl = vueData.tuiguangurl
          this.cankaourl = vueData.cankaourl
          this.reg_user_num = vueData.reg_user_num
          this.pay_user_num = vueData.pay_user_num
          this.pay_ok = vueData.pay_ok
          this.pay_no = vueData.pay_no
          this.$refs.form.style.visibility = 'visible'
        }else {
          this.$toast('请刷新页面...','fail')
        }
      },
      async savingInfo() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=tixian_yongjin')
        if(vueData.response == 200 ) {
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.getAllUser()
            }})
        }else {
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  a {
    text-decoration: none;
  }
  .crumb-home {
    padding-left: 28px;
    background: url(../../assets/imgs/zhanghu.png) no-repeat left center;
  }
  .zj-form {
    padding-top: 20px;
    color: #ccc;
  }
  .zj-form .form-group {
    margin-bottom: 12px;
    line-height: 30px;
    padding: 5px 0;
  }
  .form-horizontal .form-group {
    margin-right: -15px;
    margin-left: -15px;
  }
  .zj-control-label {
    width: 10px;
    padding-right: 0;
    text-align: right;
    color: #666;
    font-size: 14px;
    padding-right: 20px;
  }
  .zj-form-control{
    padding-right: 5px;
    padding-left: 5px;
    white-space: nowrap;
    color: #333;
    background-color: #fff;
    background-image: none;
    outline: none;
    font-size: 14px;
  }
  .zj-form-control-container {
    width: 378px;
  }
  .user-label {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: no-repeat center;
    vertical-align: -8%;
  }
  .auth_inauth {
    background-image: url(../../assets/imgs/auth_inauth.png);
  }
  .zj-form-control .btn-primary {
    line-height: 30px;
    font-size: 14px;
    margin-left: 10px;
    border: 1px solid #009fd9;
    color: #009fd9;
    padding: 0 12px;
    float: right;
  }
  .zj-form-control .btn-primary:hover {
    background-color: #d6f4ff;
  }
  .btn-strong {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    border: none;
    padding: 0 30px;
    background-color: #04baf0;
    outline: none;
    color: #fff;
  }
  .zj-form zj-btn {
    font-size: 12px;
  }
  .zj-btn {
    display: inline-block;
    border-radius: 2px;
    cursor: pointer;
  }
  .btn-strong:hover, .btn-strong:focus {
    color: #fff;
    text-decoration: none;
    background-color: #04baf0;
  }

</style>



// WEBPACK FOOTER //
// src/pages/caiwu/client.vue